import { render, staticRenderFns } from "./ProjectTimelineItem.vue?vue&type=template&id=5680c7bd"
import script from "./ProjectTimelineItem.vue?vue&type=script&lang=js"
export * from "./ProjectTimelineItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectTimelineItem.vue?vue&type=style&index=0&id=5680c7bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports